import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function Seo({ resumeData }) {
  const name = resumeData?.name || 'Portfolio';
  const title = `${name} | Full Stack Developer`;
  const description =
    resumeData?.roleDescription ||
    'Portfolio of a full stack developer with projects, experience, and contact details.';
  const reviews =
    resumeData?.testimonials?.map((item) => ({
      '@type': 'Review',
      reviewBody: item.quote || item.description,
      author: {
        '@type': 'Person',
        name: item.name || item.author || 'Client',
      },
      itemReviewed: {
        '@type': 'Person',
        name,
      },
    })) || [];

  const canonicalBase = resumeData?.website || (typeof window !== 'undefined' ? window.location.origin : '');
  const canonicalUrl = canonicalBase ? `${canonicalBase.replace(/\/$/, '')}/` : '';

  const socialImage = canonicalBase ? `${canonicalBase.replace(/\/$/, '')}/images/icon.png` : '';

  const personSchema = {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name,
    url: canonicalUrl || undefined,
    sameAs: resumeData?.socialLinks?.map((item) => item.url) || [],
    jobTitle: resumeData?.role || 'Full Stack Developer',
    description,
    image: socialImage || undefined,
    review: reviews.length ? reviews : undefined,
    address: resumeData?.address
      ? {
          '@type': 'PostalAddress',
          addressCountry: resumeData.address,
        }
      : undefined,
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {socialImage && <meta property="og:image" content={socialImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {socialImage && <meta name="twitter:image" content={socialImage} />}

      <script type="application/ld+json">{JSON.stringify(personSchema)}</script>
    </Helmet>
  );
}
